import React, { useState } from "react";
import MainBanner from "../../components/MainComponents/MainBanner";
import Footer from "../../components/MainComponents/Footer";
import {
  aboutBanners,
  bannerTestinomialDetailImage,
  doctorHomeImages,
  mainTitle,
  servicesImages,
  specImages,
} from "../../config";
import FilterSection from "../../components/AboutComponents/FilterSection";
import TeamIntroduction from "../../components/AboutComponents/TeamIntroduction";
import SpecialtiesSection from "../../components/AboutComponents/SepcialtitesSection";
import { TestimonialsSection } from "../../components/AboutComponents/TestimonialsSection";
import TeamSection from "../../components/AboutComponents/TeamSection";
import ContactHeader from "../../components/MainComponents/ContactHeader";

// Team data
const experts = [
  {
    name: "Dr. Aditya Shashtri",
    specialization: "Physiotherapist",
    degree: "M.Sc (Physiotherapist)",
    experience: "18 years of experience",
    tags: ["Knee Pain", "Hip Pain", "Sports Surgeries"],
    image: doctorHomeImages.doctor4,
  },
  {
    name: "Dr. Paul Sidhu",
    specialization: "Physiotherapist",
    degree: "M.Sc (Physiotherapist)",
    experience: "19 years of experience",
    tags: ["Shoulder Pain", "Back Pain", "Knee Pain"],
    image: doctorHomeImages.doctor6,
  },
  {
    name: "Dr. Gargi Naha",
    specialization: "Physiotherapist",
    degree: "MPTh (Ortho)",
    experience: "14 years of experience",
    tags: ["Sports Injury", "Neck Pain", "Back Pain"],
    image: doctorHomeImages.doctor5,
  },
];

const categories = [
  "View All",
  "Business Partner",
  "Clinic Director",
  "Clinic Manager",
  "Physiotherapist",
  "Physiotherapist Assistant",
  "Pedorthist",
  "Chiropractor",
  "Kinesiologist",
  "Massage Therapist",
  "Clinic Coordinator",
  "Marketing",
];

const Aboutus = () => {
  return (
    <div>
      <ContactHeader/>
      {/* Main Banner */}
      <MainBanner
        bannerTitle={mainTitle}
        showButton={false}
        banenrHeadline="Meet Our Experts"
        bannerDescription="Dedicated professionals leading the way in physiotherapy care"
        
        mainBannerImages = {[aboutBanners.bannerOne,aboutBanners.bannerTwo,aboutBanners.bannerThree]}
      />

      

     {/* About Us Section */}
<section className="bg-gradient-to-br from-gray-50 to-gray-100 py-20">
  <div className="container mx-auto px-6 lg:px-20">
    <div className="text-center">
      <h2 className="text-5xl font-bold text-primary mb-6">
        About Us
      </h2>
      <p className="text-lg text-gray-600 mb-12 max-w-2xl mx-auto">
        Welcome to <span className="font-semibold">ConklinPhysioChiro+</span>, where our mission is to guide you on your journey to optimal health and vitality. At our state-of-the-art facility, we combine the art and science of physiotherapy, chiropractic care, and massage therapy to help you reclaim a life of movement, comfort, and overall well-being.
      </p>
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mt-8">
      {/* Philosophy Section */}
      <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-2xl transition-shadow duration-300">
        <h3 className="text-3xl font-semibold text-primary mb-4">Our Philosophy</h3>
        <p className="text-gray-700 text-lg leading-relaxed">
          We believe that every person has the potential to live a full and active life, free from pain and limitations. Our focus is on identifying and addressing the root causes of your discomfort rather than just masking symptoms. We are dedicated to bringing you back to a state of complete functionality, empowering you to thrive in every aspect of your life.
        </p>
      </div>

      {/* Our Team Section */}
      <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-2xl transition-shadow duration-300">
        <h3 className="text-3xl font-semibold text-primary mb-4">Our Team</h3>
        <p className="text-gray-700 text-lg leading-relaxed">
          Our team of experienced physiotherapists, chiropractors, and massage therapists is committed to providing personalized care tailored to your unique needs. We take the time to listen to your concerns, thoroughly assess your condition, and develop a comprehensive treatment plan designed to restore your health and enhance your quality of life.
        </p>
      </div>
    </div>

    {/* What We Offer Section */}
    <div className="bg-gradient-to-br from-darkBackground to-primary text-white rounded-lg shadow-lg p-8 mt-12 hover:shadow-2xl transition-shadow duration-300">
      <h3 className="text-3xl font-semibold mb-6">What We Offer</h3>
      <ul className="list-disc list-inside text-lg space-y-4">
        <li>
          <strong>Physiotherapy:</strong> Our physiotherapists utilize evidence-based techniques to address musculoskeletal issues, improve mobility, and strengthen your body. From rehabilitation programs to preventative care, we focus on helping you recover and prevent future injuries.
        </li>
        <li>
          <strong>Chiropractic Care:</strong> Our chiropractors specialize in diagnosing and treating spinal misalignments and other related conditions. By using gentle adjustments and supportive therapies, we aim to optimize your spinal health and overall function.
        </li>
        <li>
          <strong>Massage Therapy:</strong> Our skilled massage therapists provide a range of therapeutic techniques designed to reduce muscle tension, alleviate pain, and promote relaxation. Whether you need relief from chronic stress or are seeking recovery from an injury, our massage therapy services can support your overall treatment plan.
        </li>
      </ul>
    </div>

    {/* Our Commitment Section */}
    <div className="mt-12">
      <div className="bg-white rounded-lg shadow-lg p-8 hover:shadow-2xl transition-shadow duration-300">
        <h3 className="text-3xl font-semibold text-primary mb-4">Our Commitment</h3>
        <p className="text-gray-700 text-lg leading-relaxed">
          At <span className="font-semibold"> ConklinPhysioChiro+</span>, we are more than just a healthcare provider—we are your partners in health. We are committed to creating a supportive and compassionate environment where you can feel confident in your path to recovery. Your well-being is our top priority, and we are here to guide you every step of the way.
        </p>
      </div>
    </div>
  </div>
</section>

{/* Team Introduction */}
{/* <TeamIntroduction /> */}

      {/* Team Section */}
      {/* <TeamSection experts={experts} /> */}

      {/* Specialties Section */}
      <SpecialtiesSection />

      {/* Testimonials Section */}
      <TestimonialsSection />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Aboutus;
